import { UserRole } from 'common/types'
import { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useAssertedJoinedRoomAddress } from 'room/common/use-joined-room-address'
import { useAssertedWorkflowUser } from 'room/common/use-workflow-user'
import { assertUnreachable } from 'utils/unreachable'
import {
	clearVcrRoomAddress,
	setVcrRoomAddress,
} from 'video-conference-media/redux'
import { RoomTraineeWebinar } from './room-trainee-webinar'
import { RoomTrainerWebinar } from './room-trainer-webinar'

export const WebinarRoom: FC = () => {
	const workflowUser = useAssertedWorkflowUser()
	const joinedRoomAddress = useAssertedJoinedRoomAddress()
	const dispatch = useDispatch()

	useEffect(() => {
		if (!joinedRoomAddress) {
			return
		}
		dispatch(setVcrRoomAddress(joinedRoomAddress))

		return () => {
			dispatch(clearVcrRoomAddress())
		}
	}, [dispatch, joinedRoomAddress])

	switch (workflowUser.role) {
		case UserRole.UPPER_ECHELON:
			return <RoomTrainerWebinar />
		case UserRole.END_USER:
			return <RoomTraineeWebinar />
		default:
			assertUnreachable('UserRole', workflowUser.role)
	}
}
